// Module
var code = `<jsonforms-control>
  <input
    type="text"
    ng-model="vm.resolvedData[vm.fragment]"
    ng-change="vm.triggerChangeEvent()"
    class="form-control"
    id="{{vm.id}}"
  />

  <input
    type="file"
    ng-fileread="vm.handleFileRead"
    id="file:{{vm.id}}"
    style="display: none"
  />

  <label
    for="file:{{vm.id}}"
    class="button set-current-file"
    style="display: inline-block; margin-left: 5px;"
  >
    <span class="fa fa-search dynamic-set-select-file"></span>
  </label>
</jsonforms-control>
`;
// Exports
export default code;